/* ContactsView holds all contacts-related stuff */
import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import ContactList from '../widgets/contact-list.jsx';

import { updateFavicon } from '../lib/utils.js';

const messages = defineMessages({
  archived_contacts_title: {
    id: "archived_contacts",
    defaultMessage: "Archived contacts ({count})",
    description: "Label for archived chats"
  }
});

export default class ContactsView extends React.Component {
  constructor(props) {
    super(props);

    this.handleAction = this.handleAction.bind(this);

    this.state = ContactsView.deriveStateFromProps(props);
  }

  static deriveStateFromProps(props) {
    let contacts = [];
    let unreadThreads = 0;
    let archivedCount = 0;
    //console.info("deriveStateFromProps");
    props.chatList.map((c) => {
      /*
      console.info("c.private", c.private ?s? '');
      if (c.private != null && c.private.parentid != null) {
        console.info("c.private.parentid", c.private.parentid ?? '');
      }*/
      const blocked = c.acs && !c.acs.isJoiner();
      // Show only blocked contacts only when props.blocked == true.
      if (blocked && props.blocked) {
        contacts.push(c);
      }
      if (blocked || props.blocked) {
        return;
      }

      if (c.private && c.private.arch) {
        if (props.archive) {
          contacts.push(c);
        } else {
          archivedCount ++;
        }
      } else if (!props.archive) {
        contacts.push(c);
        unreadThreads += c.unread > 0 ? 1 : 0;
      }
    });
/*
    contacts.sort((a, b) => {
      return (b.touched || 0) - (a.touched || 0);
    });
*/
const sortChatList = (chatList) => {
  // Разделяем темы на уровни с безопасной проверкой
  const firstLevel = chatList.filter(item => !item.public || !item.public.parentid);
  const secondLevel = chatList.filter(item => item.public && item.public.parentid);

  // Сортируем 1-й уровень по убыванию touched
  firstLevel.sort((a, b) => {
    const aTime = a.touched?.getTime() || 0;
    const bTime = b.touched?.getTime() || 0;
    return bTime - aTime;
  });

  // Группируем второй уровень по parentid
  const secondLevelMap = {};
  for (const child of secondLevel) {
    const parentId = child.public?.parentid;
    if (!secondLevelMap[parentId]) {
      secondLevelMap[parentId] = [];
    }
    secondLevelMap[parentId].push(child);
  }

  const sortedResult = [];

  // Добавляем родителя и его дочерние темы
  for (const parent of firstLevel) {
    sortedResult.push(parent);

    const parentName = parent.name;
    const children = secondLevelMap[parentName];
    if (children) {
      children.sort((a, b) => {
        const aNum = a.public?.numdialog ?? Number.MAX_SAFE_INTEGER;
        const bNum = b.public?.numdialog ?? Number.MAX_SAFE_INTEGER;
        return aNum - bNum;
      });
      sortedResult.push(...children);
      delete secondLevelMap[parentName];
    }
  }

  // Добавляем оставшиеся "потерянные" темы второго уровня (без родителя)
  for (const orphanChildren of Object.values(secondLevelMap)) {
    sortedResult.push(...orphanChildren);
  }

  return sortedResult;
};
    
    // Использование:
    contacts = sortChatList(contacts);


    if (archivedCount > 0) {
      contacts.push({
        action: 'archive',
        title: messages.archived_contacts_title,
        values: {count: archivedCount}
      });
    }

    return {
      contactList: contacts,
      unreadThreads: unreadThreads
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.chatList != this.props.chatList ||
        prevProps.archive != this.props.archive ||
        prevProps.blocked != this.props.blocked) {
      const newState = ContactsView.deriveStateFromProps(this.props);
      this.setState(newState);
      if (newState.unreadThreads != prevState.unreadThreads) {
        updateFavicon(newState.unreadThreads);
      }
    }
  }

  handleAction(action_ignored) {
    this.props.onShowArchive();
  }

  render() {
    return (
        <FormattedMessage id="contacts_not_found"
        defaultMessage="Create your first Talk"
        description="HTML message shown in ContactList when no contacts are found">
        
        {
        (no_contacts) => <ContactList
          tinode={this.props.tinode}
          connected={this.props.connected}
          contacts={this.state.contactList}
          emptyListMessage={no_contacts}
          topicSelected={this.props.topicSelected}
          myUserId={this.props.myUserId}
          showOnline={true}
          showUnread={true}
          onTopicSelected={this.props.onTopicSelected}
          showContextMenu={this.props.showContextMenu}
          onAction={this.handleAction} 
          onNewTalk={this.props.onNewTalk}
          Survey = {this.props.Survey}//syy
          toggleSurvey = {this.props.toggleSurvey}
          TokensUsed ={this.props.TokensUsed}//syy
          Tokens ={this.props.Tokens}//syy
          />
      }</FormattedMessage>
    );
  }
};
